namespace Matrix.Rebalancer {
    export interface TradeMacroRow {
        MacroCode?: string;
        Description?: string;
        IsGlobalShortcut?: boolean;
        CustomPreProcessor?: string;
        CustomPostProcessor?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        PermittedCashAccounts?: string;
        PermittedStrategies?: string;
        IsCashTransfer?: boolean;
        CashTransferAccountCode?: string;
        CashTransferStrategies?: string;
        SessionId?: string;
        DefaultSortOrder?: number;
        PhysicalWeight?: number;
        SyntheticWeight?: number;
        Deleted?: boolean;
    }

    export namespace TradeMacroRow {
        export const idProperty = 'MacroCode';
        export const nameProperty = 'MacroCode';
        export const localTextPrefix = 'Rebalancer.TradeMacro';
        export const lookupKey = 'Rebalancer.TradeMacro';

        export function getLookup(): Q.Lookup<TradeMacroRow> {
            return Q.getLookup<TradeMacroRow>('Rebalancer.TradeMacro');
        }
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            MacroCode = "MacroCode",
            Description = "Description",
            IsGlobalShortcut = "IsGlobalShortcut",
            CustomPreProcessor = "CustomPreProcessor",
            CustomPostProcessor = "CustomPostProcessor",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            PermittedCashAccounts = "PermittedCashAccounts",
            PermittedStrategies = "PermittedStrategies",
            IsCashTransfer = "IsCashTransfer",
            CashTransferAccountCode = "CashTransferAccountCode",
            CashTransferStrategies = "CashTransferStrategies",
            SessionId = "SessionId",
            DefaultSortOrder = "DefaultSortOrder",
            PhysicalWeight = "PhysicalWeight",
            SyntheticWeight = "SyntheticWeight",
            Deleted = "Deleted"
        }
    }
}
